export default __webpack_public_path__ + "static/Gotham-Book-e27daf66a58dea832e19b2a720150f34.eot";